module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_nextfuturelab_m.7675ee55504258af0a68040ceecd5c91.png";